<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="ds-close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content>
  <ng-container *ngIf="$balanceSheet | async as balanceSheet">
    <div class="banner-header">
      <span class="ds-heading-1">{{'balanceSheet.title' | translate}}</span>
      <span class="ds-ui-3 ds-color-core-neutral-5">
        {{'balanceSheet.updatedDate' | translate: {date: formatDate(balanceSheet.updated_at, '-')} }}
      </span>
    </div>
    <div class="banner-content">
      <div class="balance-box">
        <p class="ds-heading-2">{{ 'balanceSheet.balance.title' | translate }}</p>
        <app-balance-sheet-row
          [title]="'balanceSheet.balance.totalDeposit.title' | translate"
          [amount]="balanceSheet.total_deposit"
          [info]="'balanceSheet.balance.totalDeposit.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.balance.totalWithdrawal.title' | translate"
          [amount]="balanceSheet.total_withdrawal"
          [info]="'balanceSheet.balance.totalWithdrawal.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'PERFORMANCE.accountOverview.netInvestment.name' | translate"
          [amount]="balanceSheet.net_investment"
          [info]="'PERFORMANCE.accountOverview.netInvestment.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
      </div>
      <div class="balance-box">
        <p class="ds-heading-2">{{ 'balanceSheet.portfolioOverview.title' | translate }}</p>
        <app-balance-sheet-row
          [title]="'balanceSheet.portfolioOverview.amountInMarket.title' | translate"
          [amount]="balanceSheet.account_balance"
          [info]="'balanceSheet.portfolioOverview.amountInMarket.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.portfolioOverview.amountInStocks.title' | translate"
          [amount]="balanceSheet.stocks_amount"
          [info]="'balanceSheet.portfolioOverview.amountInStocks.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.portfolioOverview.amountInBonds.title' | translate"
          [amount]="balanceSheet.bonds_amount"
          [info]="'balanceSheet.portfolioOverview.amountInBonds.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.portfolioOverview.amountInCash.title' | translate"
          [amount]="balanceSheet.amount_in_cash"
          [info]="'balanceSheet.portfolioOverview.amountInCash.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
      </div>
      <div class="balance-box">
        <p class="ds-heading-2">{{ 'balanceSheet.profitAndLoss.title' | translate }}</p>
        <app-balance-sheet-row
          [title]="'balanceSheet.profitAndLoss.totalEarned.title' | translate"
          [amount]="balanceSheet.total_earned"
          [info]="'balanceSheet.profitAndLoss.totalEarned.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.profitAndLoss.fromMarketChange.title' | translate"
          [amount]="balanceSheet.from_market_change"
          [info]="'balanceSheet.profitAndLoss.fromMarketChange.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.profitAndLoss.fromDividends.title' | translate"
          [info]="'balanceSheet.profitAndLoss.fromDividends.info' | translate"
          [amount]="balanceSheet.dividends"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.profitAndLoss.fromPromotion.title' | translate"
          [amount]="balanceSheet.from_promotion"
          [info]="'balanceSheet.profitAndLoss.fromPromotion.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
      </div>
      <div class="balance-box" *ngIf="showFees">
        <p class="ds-heading-2">{{'balanceSheet.feesAndCashback.title' | translate: {year: year} }}</p>
        <app-balance-sheet-row
          [title]="'balanceSheet.feesAndCashback.inyovaManagementFees.title' | translate"
          [amount]="balanceSheet.inyova_mgmt_fees"
          [info]="'balanceSheet.feesAndCashback.inyovaManagementFees.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.feesAndCashback.custodianFees.title' | translate"
          [amount]="balanceSheet.custodian_fees"
          [info]="'balanceSheet.feesAndCashback.custodianFees.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.feesAndCashback.foundationFees.title' | translate"
          [amount]="balanceSheet.foundation_fees"
          [info]="'balanceSheet.feesAndCashback.foundationFees.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
        <app-balance-sheet-row
          [title]="'balanceSheet.feesAndCashback.totalFeesCashback.title' | translate"
          [amount]="balanceSheet.reimbursements"
          [info]="'balanceSheet.feesAndCashback.totalFeesCashback.info' | translate"
          [currency]="currency"
        ></app-balance-sheet-row>
      </div>
      <app-ds-feedback-loop feedbackSource="DetailedReporting" (trackFeedback)="onTrackFeedback($event)">{{'feedbackLoopWidget.title' | translate}}</app-ds-feedback-loop>
    </div>
  </ng-container>
</ion-content>
